import "./Home.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import HealthcareDesignedForYou from "./sections/HealthcareDesignedForYou";
import WhyChooseRestore from "./sections/WhyChooseRestore";
import TheCaymanWellnessPhilosophy from "./sections/TheCaymanWellnessPhilosophy";
import LegalExpertise from "./sections/LegalExpertise";
import RentalTiers from "./sections/RentalTiers";
import VoicesOfHowardCounty from "./sections/VoicesOfHowardCounty";
import ReadyForYourBestSmile from "./sections/ReadyForYourBestSmile";
import PremiumService from "./sections/PremiumService";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ClinicHeader />
      <HealthcareDesignedForYou />
      <PremiumService />
      <WhyChooseRestore />
      <TheCaymanWellnessPhilosophy />
      <LegalExpertise />
      <RentalTiers />
      <VoicesOfHowardCounty />
      <ReadyForYourBestSmile />
      <Footer />
    </div>;
}